<template>
  <div class="app-forgot-password-sms-code">
    <form class="form-inline" @submit.prevent="next()" :id="'form' + _uid" novalidate>
      <fieldset>
        <legend class="text-xl visually-hidden">Token-Eingabe</legend>
        <div class="inputs-container" :id="'sms-code-' + _uid">
          <div class="input-field">
            <label class="text-base-medium mandatory" :for="'input-sms-code-' + _uid">
              Token
            </label>
            <ValidationIndicator :dirty="$v.code.$dirty" :valid="!$v.code.$invalid">
              <input
                type="text"
                required
                name="code"
                :id="'input-sms-code-' + _uid"
                v-model="code"
                @input="checkAndSaveCode"
                class="input"
                :class="{ error: !isValid('code') }"
                placeholder="6-stelligen Code hier eingeben"
              />
            </ValidationIndicator>
            <span v-if="displayErrorMessage" class="text-sm text-error">
              Sie haben keinen gültigen Code angegeben
            </span>
          </div>
        </div>
      </fieldset>
    </form>
    <dyn-slot :slot-data="slotData">
      <slot name="txtAfter"></slot>
    </dyn-slot>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { maxLength, minLength, required } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'
import isValid from '../../../../../mixins/isValid'
import ValidationIndicator from '@/components-v2/generic/ValidationIndicator.vue'

export default {
  name: 'ResetPasswordConfirmationToken',
  data() {
    return {
      code: '',
      displayErrorMessage: false,
      codeSaved: false
    }
  },
  components: {
    ValidationIndicator
  },
  props: {
    minTokenLength: {
      type: Number,
      default: 8
    },
    maxTokenLength: {
      type: Number,
      default: 8
    }
  },
  methods: {
    checkAndSaveCode() {
      this.$v.code.$touch()

      if (!this.$v.code.$invalid && this.code.length >= this.minTokenLength && !this.codeSaved) {
        this.captureToken(this.code)
        this.codeSaved = true
        this.$emit('code-validated')
      }

      if (this.$v.code.$invalid && this.codeSaved) {
        this.codeSaved = false
      }

      this.displayErrorMessage = this.$v.code.$dirty && this.$v.code.$invalid
    },
    ...mapMutations('resetPassword', ['captureToken'])
  },
  mixins: [validationMixin, isValid],
  validations() {
    return {
      code: {
        required,
        minLength: minLength(this.minTokenLength),
        maxLength: maxLength(this.maxTokenLength)
      }
    }
  },
  computed: {
    slotData() {
      return {
        code: this.code,
        displayErrorMessage: this.displayErrorMessage
      }
    }
  }
}
</script>
